import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useListItem, useMergeRefs } from '@floating-ui/react';
import classnames from 'classnames';
import { useDropdownContext } from '../../context/ButtonDropdownContext.js';

const ButtonDropdownInteractiveWrapper = ({ className , children , isDisabled , childElement ,  })=>{
    const { floatingProps: { getItemProps  } ,  } = useDropdownContext();
    const { ref  } = useListItem();
    const itemRef = React.useRef(null);
    const handleFocus = ()=>{
        if (itemRef.current) {
            //This slider is weird one and should be replaced with something accessible: CXCD-10123
            const elementType = childElement === 'slider' ? '[role="slider"]' : childElement;
            const element = itemRef.current.querySelector(elementType);
            if (!element) {
                console.error('Could not find child element with tag: ', elementType);
                return;
            }
            element.focus();
        }
    };
    const megedRefs = useMergeRefs([
        ref,
        itemRef
    ]);
    // The disabled prop will make sure the element wont be used in the focus/tab cycle of the list.
    const props = swcHelpers.objectSpread({}, isDisabled ? {
        disabled: true
    } : swcHelpers.objectSpread({
        tabIndex: 0
    }, getItemProps({
        onFocus: handleFocus
    })));
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, props, {
        ref: megedRefs,
        "data-t": "button-dropdown__interactive-wrapper",
        className: classnames('button-dropdown__interactive-wrapper', className)
    }), children);
};

export { ButtonDropdownInteractiveWrapper };
//# sourceMappingURL=ButtonDropdownInteractiveWrapper.js.map
